import { render, staticRenderFns } from "./HazeWidgetFullVersion.vue?vue&type=template&id=36e7e2c2&"
import script from "./HazeWidgetFullVersion.vue?vue&type=script&lang=js&"
export * from "./HazeWidgetFullVersion.vue?vue&type=script&lang=js&"
import style0 from "./HazeWidgetFullVersion.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports